<template>
    <el-dialog
      :destroy-on-close="true"
      :title="title || '提示'"
      :visible.sync="visible"
      :width="width"
      :before-close="handleClose"
    >
      <span>
        <slot></slot>
      </span>
      <span v-if="footer" slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleOk">确 定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  export default {
    data() {
      return {}
    },
    props: ['visible', 'title', 'width', 'footer'],
    mounted() {
      console.log(this.title)
    },
  
    methods: {
      handleClose() {
        this.$emit('cancel')
        this.$emit('change', false)
      },
      handleOk() {
        console.log()
        this.$emit('ok')
      },
    },
  }
  </script>
  
  <style scoped></style>